export default function isServerError(error: any) {
  const isServerError = error && error.message && (!error.networkError?.statusCode || error.networkError.statusCode >= 500);
  return isServerError;
}
